import React from 'react';
import { Divider } from '../../components/divider';
export default function MobileDivider(props) {
    const { show, section } = props;
    const { separatorColor } = section;
    if (!show) {
        return null;
    }
    return (React.createElement(Divider, { borderWidth: "0px", width: "0px", borderColor: separatorColor, cssClass: "html-emails-footer-divider" }));
}
//# sourceMappingURL=mobile-divider.js.map